import format from 'date-fns/format'
import locales from '../locales'
import { getDateFromString } from '../getDateFromString'

const defaultDateFormats = {
  en: 'd MMM yyyy',
  nl: 'd MMM yyyy',
  fr: 'd MMM.yyyy',
  de: 'd MMM yyyy',
  hu: 'yyyy. MMMM',
  es: 'd MMM yyyy',
  pt: 'd MMM yyyy',
}

export function formatDate(date, formatStr, language) {
  const dateFormat = formatStr || defaultDateFormats[language]
  let dateObject = date
  if (typeof dateObject === 'string') {
    dateObject = getDateFromString(date)
  }
  if (typeof dateObject !== 'object') {
    throw new Error(
      `Dates passed to 'formatDate()' must be of type 'object', got '${typeof date}' instead.`
    )
  }
  return format(dateObject, dateFormat, {
    locale: locales[language],
  })
}
